import React from "react"
import Helmet from "react-helmet"
import { graphql } from "gatsby"

import { SEO } from "components"

import Hero from "./_Hero"
import Feed from "./_Feed"
import Content from "./_Content"

function TalkingShopPost({ data }) {
  const { contentfulTalkingShopCategory } = data
  const { contentfulTalkingShopPost } = data
  const { allContentfulTalkingShopPost } = data

  return (
    <>
      <SEO
        title={contentfulTalkingShopPost?.title}
        description={contentfulTalkingShopPost?.excerpt?.internal?.content}
        image={contentfulTalkingShopPost?.image}
        article
      />
      <Helmet>
        <script type="application/ld+json">
          {`{
              "@context": "https://schema.org",
              "@type": "NewsArticle",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.hearthsidefoods.com/news/${
                  (contentfulTalkingShopPost?.category?.slug === "/"
                    ? ""
                    : contentfulTalkingShopPost?.category?.slug + "/") +
                  contentfulTalkingShopPost.slug +
                  "/"
                }"
              },
              "headline": "${contentfulTalkingShopPost?.title}",
              "image": [
                "${contentfulTalkingShopPost?.image?.file?.url}"
              ],
              "datePublished": "${contentfulTalkingShopPost?.date}",
              "dateModified": "${contentfulTalkingShopPost?.updatedAt}",
              "publisher": {
                "@type": "Organization",
                "name": "Hearthside Food Solutions",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://images.ctfassets.net/8lunq79kzgy8/7sYUW060h6VqUvFVeTS1zP/806076be349641ac88c0c32858befb19/Logo.svg"
                }
              }
            }`}
        </script>
      </Helmet>
      <main>
        <Hero
          category={contentfulTalkingShopCategory}
          post={contentfulTalkingShopPost}
        />
        <Content post={contentfulTalkingShopPost} />
        <Feed
          category={contentfulTalkingShopCategory}
          posts={allContentfulTalkingShopPost}
        />
      </main>
    </>
  )
}
export const pageQuery = graphql`
  query TalkingShopPostQuery($slug: String, $category: String) {
    contentfulTalkingShopPost(slug: { eq: $slug }) {
      updatedAt
      date
      slug
      title
      category {
        ... on ContentfulTalkingShopCategory {
          name
          slug
        }
      }
      image {
        ...AssetFragment
        gatsbyImageData(width: 768, placeholder: BLURRED)
      }
      excerpt {
        internal {
          content
        }
      }
      content {
        raw
        references {
          ...AssetFragment
          __typename
          contentful_id
          gatsbyImageData(width: 768, layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
    contentfulTalkingShopCategory(slug: { eq: $category }) {
      color
      name
      slug
    }
    allContentfulTalkingShopPost(
      filter: { category: { slug: { eq: $category } }, slug: { ne: $slug } }
    ) {
      nodes {
        slug
        title
        category {
          ... on ContentfulTalkingShopCategory {
            name
            slug
          }
        }
        image {
          ...AssetFragment
          gatsbyImageData(width: 768, layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  }
`

export default TalkingShopPost
